/**
 * Read listing data injected at build time by inject-seo.js so the first client
 * render matches the react-snap snapshot (avoids React hydration #418/#423).
 */
export function getPrefetchedListing(pathname) {
  if (typeof window === "undefined") return null;
  const bucket = window.__RETREAT_LISTING__;
  if (!bucket || typeof bucket !== "object") return null;
  const key = pathname === "" ? "/" : pathname;
  const entry = bucket[key];
  if (!entry || !Array.isArray(entry.items)) return null;
  return entry;
}
